module.exports = __webpack_public_path__ + "static/mobile-404@2x-74c552b65a13082b89b8d5b0c22ce501.png";